import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { AmplitudeService } from '@inyova/inyova-shared';

@Component({
  selector: 'app-inyova-grow-project-doc',
  templateUrl: './inyova-grow-project-doc.component.html',
  styleUrls: ['./inyova-grow-project-doc.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class InyovaGrowProjectDocComponent {
  @Input() doc: string;
  @Input() title: string;

  constructor(private amplitudeService: AmplitudeService) {}

  openDocPDF(doc, title: string) {
    this.amplitudeService.trackEvent('Grow Investment Documents Opened', { investment_flow_step: 'grow_project_info', doc_name: title });
    void Browser.open({
      url: doc
    });
  }
}
